import $ from 'jquery';
import async from 'async';

const TICK_INTERVAL = 200;
const DEFAULT_PING_INTERVAL = 15000;

class Pingator {
  constructor(options) {
    if (!options) { options = {}; }
    this.options = options;
    ({timeInterval: this.timeInterval, courseId: this.courseId} = this.options);
    if (!this.timeInterval) { this.timeInterval = DEFAULT_PING_INTERVAL; }

    this.postUrl = SOPHIA.Routes.continue_to_learn_path();

    this.sendQueue = async.queue((task, callback) => this._send(task, callback));

    this.tick = 0;
    this.tickInterval = setInterval(() => {
      this._tick();
    }
    , TICK_INTERVAL);

    this.hasFocus = true;
    $(window).on('focus', () => this._handleFocus());
    $(window).on('blur', () => this._handleBlur());
    $(window).on('unload', () => {
      this.onUnload = true;
      if (this.target) {
        this._send({target: this.target, event: 'close'}, function() {});
      }
    });

    if (this.options.target) {
      this.setTarget(this.options.target);
    }
  }

  setTarget(target) {
    this._queueMessage('stop');
    this.target = null;
    if (target) {
      this.target = { id: target.id, type: target.type, firstSend: true };
    }
    this._queueMessage('start');
  }

  _send(task, callback) {
    const msg = {
      id: task.target.id,
      type: task.target.type,
      first_send: task.target.firstSend,
      event: task.event
    };
    if (this.courseId) { msg.course_id = this.courseId; }

    const xhrData = {
      url: this.postUrl,
      type: 'post',
      data: msg,
      success: () => {
        if (task.target) { task.target.firstSend = false; }
        this._checkInternetConnectionPopup(true);
      },
      error: (xhr) => {
        // Show popup only if no response from server
        if (!xhr.status) { this._checkInternetConnectionPopup(false); }
      },
      complete() {
        callback();
      }
    };

    SOPHIA.ajax(xhrData);
  }

  _queueMessage(event) {
    if (this.target) { this.sendQueue.push({target: this.target, event}); }
    this.tick = 1;
  }

  _handleFocus() {
    if (this.target) { this.target.firstSend = true; }
    this._queueMessage('focus');
    this.hasFocus = true;
  }

  _handleBlur() {
    this._queueMessage('blur');
    this.hasFocus = false;
  }

  _tick() {
    if ((0 === this.tick) && this.hasFocus) {
      this._queueMessage('ping');
    }

    this.tick += 1;

    // Send message on next call
    if (this.tick > (this.timeInterval / TICK_INTERVAL)) {
      this.tick = 0;
    }
  }

  _checkInternetConnectionPopup(haveInternetConnection) {
    if (!haveInternetConnection && (this.previousCheck === false)) { // this.previousCheck === false
      this._showMessagePopup();
    } else if (!haveInternetConnection) {
      this.previousCheck = false;
    } else {
      this.previousCheck = true;
      if (this.messagePopupShown) { this._hideMessagePopup(); }
    }
  }

  _showMessagePopup() {
    if (!this.messagePopupShown && !this.onUnload) {
      const modalMessage = `We cannot process your request at this time. \
Please check your internet connection and try again.`;
      SOPHIA.modalMessage(modalMessage, 'error', undefined, true);
      this.messagePopupShown = true;
    }
  }

  _hideMessagePopup() {
    this.messagePopupShown = false;
    SOPHIA.closeOverlayBox();
  }
};


// Pingator vars in SOPHIA namespace
SOPHIA.pingator = null;
SOPHIA.initPingator = function(options) {
  if (!options) { options = {}; }
  SOPHIA.pingator = new Pingator(options);
};
